module.exports = __webpack_public_path__ + "static/media/paid-light.d5dd4f6a.svg";